<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2020-12-21 14:13:12
 * @LastEditors: huhu
 * @LastEditTime: 2025-04-22 16:55:32
 * @FilePath: \heshan_web\src\views\deviceMonitor\manipulation.vue
-->

<template>
  <div class="manipulation">
    <div v-loading="loading" element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(256, 256, 256, 0.9)" :element-loading-text="$t('manipulation.executing')">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('manipulation.sglOpera')" name="first">
          <span slot="label"><i class="el-icon-document"></i>{{ $t('manipulation.sglOpera') }}</span>
        </el-tab-pane>
        <el-tab-pane :label="$t('manipulation.bulkOpera')" name="second">
          <span slot="label"><i class="el-icon-document-copy"></i> {{ $t('manipulation.bulkOpera') }}</span>
        </el-tab-pane>

      </el-tabs>
      <div class="mantit">
        <p class="p1"></p>
        <p class="p2"></p>
        <span class="titinfo">{{ $t('realdetile.eleInfo') }}</span>
        <prowerSetting @selectStation="selectStation" :onLine='onLine' style="margin-left:20px" />
        <div class="proname" v-if="activeName != 'first'">{{ $t('manipulation.devName') }}：{{ proname }}</div>
      </div>
      <div class="deviceinfo" v-if="activeName == 'first'">
        <div class="info_con">
          <div class="info_list">
            <div class="info_name">{{ $t('manipulation.devName') }}:</div>
            <div class="info_val">{{ deviceinfo[1] && deviceinfo[1].projectName }}</div>
          </div>
          <div class="info_list">
            <div class="info_name">{{ $t('manipulation.buildNum') }}:</div>
            <div class="info_val">{{ deviceinfo[1] && deviceinfo[0].towerNumber }}</div>
          </div>
          <div class="info_list">
            <div class="info_name">{{ $t('manipulation.ladderNum') }}:</div>
            <div class="info_val">{{ deviceinfo[1] && deviceinfo[0].stairsNumber }}</div>
          </div>
          <div class="info_list">
            <div class="info_name">{{ $t('manipulation.airModel') }}:</div>
            <div class="info_val">{{ deviceinfo[1] && deviceinfo[0].devModelName }}</div>
          </div>

          <div class="info_list info_list1">
            <div class="info_name">{{ $t('manipulation.installAddress') }}:</div>
            <div class="info_val">{{ deviceinfo[1] && deviceinfo[1].address }}</div>
          </div>
        </div>
      </div>
      <div v-if="activeName != 'first'">
        <el-table :data="devicelist" ref="datatable" :row-key="getRowKeys" style="width: 100%">
          <el-table-column type="selection" :reserve-selection="true" width="55">
          </el-table-column>
          <el-table-column v-for="(item, index) in column" :prop="item.prop" :label="item.label" align="center"
            :key="index" :width="item.width">
          </el-table-column>

        </el-table>
        <div style="text-align:end;margin-top:15px">
          <el-pagination @current-change="handleCurrentChange" :currentPage="page.current" :page-size="10"
            layout="total, prev, pager, next" :total="totals">
          </el-pagination>
        </div>
      </div>
      <div class="mantit">
        <p class="p1"></p>
        <p class="p2"></p>
        <span class="titinfo">{{ $t('manipulation.executionResult') }}</span>
        <!-- <prowerSetting @selectStation="selectStation" /> -->
      </div>
      <div class="instr">
        <div class="instr_con">
          <p v-for="(item, index) in ins" :key="index">
            {{ item }}
          </p>

        </div>
      </div>
      <div v-if="activeName == 'first'">
        <div class="mantit">
          <p class="p1"></p>
          <p class="p2"></p><span class="titinfo">{{ $t('manipulation.airModelSetting') }}</span>
        </div>
        <div style="height:140px">
          <div class="oper" style="float:left">
            <div class="oper_con">
              <div class="oper_left">
                <div class="oper_but" :class="runStatus == '0' ? 'oper_but1' : ''" @click="setwrite('0')">
                  <i class="el-icon-user"></i> {{ $t('manipulation.manual') }}
                </div>
              </div>
              <div><el-switch v-model="runStatus" active-value='1' inactive-value='0' active-color="#67C23A"
                  :inactive-color="runStatus === '' ? '#C0C4CC' : '#67C23A'" disabled></el-switch></div>
              <div class="oper_left">
                <div class="oper_but" :class="runStatus == '1' ? 'oper_but1' : ''" @click="setwrite('1')"><i
                    class="el-icon-date"></i> {{ $t('manipulation.timing') }} </div>
              </div>
            </div>

          </div>
          <div class="oper" style="margin-left:3%;float:left">
            <div class="oper_con">
              <div class="oper_left">
                <div class="oper_but" :class="sleepStatus == '0' ? 'oper_but1' : ''"
                  @click="setsleep('0')">
                  {{ $t('manipulation.sleepModeOff') }} </div>
              </div>
              <div><el-switch v-model="sleepStatus" active-value='1' inactive-value='0' active-color="#67C23A"
                  :inactive-color="sleepStatus === '' ? '#C0C4CC' : '#67C23A'" disabled></el-switch></div>

              <div class="oper_left">
                <div class="oper_but" :class="sleepStatus == '1' ? 'oper_but1' : ''" @click="setsleep('1')">
                  {{ $t('manipulation.sleepModeOn') }} </div>
              </div>
            </div>

          </div>
        </div>
        <div class="mantit">
          <p class="p1"></p>
          <p class="p2"></p><span class="titinfo">{{ $t('manipulation.airParameterSetting') }}</span>
        </div>
        <div class="par">
          <div class="par_left">
            <div class="par_con">
              <span>{{ $t('manipulation.manModeParSetting') }}</span>
              <div class="oper_left" @click="par_set('hanld')">
                <div class="oper_but oper_but2" :class="runStatus == '0' ? '' : 'disab'"> <i
                    class="el-icon-user"></i>{{ $t('manipulation.ParSetting') }}</div>
              </div>
            </div>
          </div>
          <div class="par_left par_right">
            <div class="par_con">
              <span>{{ $t('manipulation.timModeParSetting') }}</span>
              <div class="oper_left" @click="par_set('time')">
                <div class="oper_but oper_but2" :class="runStatus == '1' ? '' : 'disab'"> <i class="el-icon-date"></i>{{
        $t('manipulation.ParSetting') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeName != 'first'">
        <div class="mantit">
          <p class="p1"></p>
          <p class="p2"></p><span class="titinfo">{{ $t('manipulation.airModelSetting') }}</span>
        </div>
        <div style="height:140px">
          <div class="oper" style="float:left">
            <div class="oper_con">
              <div class="oper_left">
                <div class="oper_but" :class="runStatusall == '0' ? 'oper_but1' : ''"
                  @click="setwrite('0')">
                  <i class="el-icon-user"></i>{{ $t('manipulation.manual') }}
                </div>
              </div>
              <div><el-switch v-model="runStatusall" active-value='1' inactive-value='0' active-color="#67C23A"
                  :inactive-color="runStatusall === '' ? '#C0C4CC' : '#67C23A'" disabled></el-switch></div>
              <div class="oper_left">
                <div class="oper_but " :class="runStatusall == '1' ? 'oper_but1' : ''" @click="setwrite('1')"><i
                    class="el-icon-date"></i>{{ $t('manipulation.timing') }} </div>
              </div>
            </div>
          </div>
          <div class="oper" style="margin-left:3%;float:left">
            <div class="oper_con">
              <div class="oper_left">
                <div class="oper_but" :class="sleepStatus1 == '0' ? 'oper_but1' : ''"
                  @click="setsleep('0')">
                  {{ $t('manipulation.sleepModeOff') }} </div>
              </div>
              <div><el-switch v-model="sleepStatus1" active-value='1' inactive-value='0' active-color="#67C23A"
                  :inactive-color="sleepStatus1 === '' ? '#C0C4CC' : '#67C23A'" disabled></el-switch></div>

              <div class="oper_left">
                <div class="oper_but" :class="sleepStatus1 == '1' ? 'oper_but1' : ''" @click="setsleep('1')">
                  {{ $t('manipulation.sleepModeOn') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="mantit">
          <p class="p1"></p>
          <p class="p2"></p><span class="titinfo">{{ $t('manipulation.airParameterSetting') }}</span>
        </div>
        <div class="par">
          <div class="par_left">
            <div class="par_con">
              <span>{{ $t('manipulation.manModeParSetting') }}</span>
              <div class="oper_left" @click="par_set('hanld', '0')">
                <div class="oper_but oper_but2" :class="runStatusall == '0' ? '' : 'disab'"> <i
                    class="el-icon-user"></i>{{ $t('manipulation.ParSetting') }}</div>
              </div>
            </div>
          </div>
          <div class="par_left par_right">
            <div class="par_con">
              <span>{{ $t('manipulation.timModeParSetting') }}</span>
              <div class="oper_left" @click="par_set('time', '1')">
                <div class="oper_but oper_but2" :class="runStatusall == '1' ? '' : 'disab'"> <i
                    class="el-icon-date"></i>
                  {{ $t('manipulation.ParSetting') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Parmodel :dialogStationVisible='dialogStationVisible' :title='title' :command-submitting='commandSubmitting' @closepar='closepar' ref='parmodel'
        @parsocket='parsocket' @commandaccepted='commandAccepted' @commandfailure='commandFailure' />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import prowerSetting from '@/components/power/prowerSetting';
import { getDeviceListById, multiplewrite, getCommandBatch, deviceinfo, projectinfo, multiplecurrent } from "@/api/devicemon";
import { sendSock, initWebSocket, websocketclose } from '@/util/socket.js';
import Parmodel from './parmodel'
import { formatRunStatus, formatBinaryStatus, isCurrentRequest } from '@/util/monitorMetrics'
 import { throttle } from "@/util/util"

export default {
  name: 'manipulation',
  components: {
    prowerSetting,
    Parmodel
  },
  data() {
    return {
      loading: false,
      devicelist: [

      ],
      ins: '',
      insname: '',
      activeName: 'first',
      wayinfo: '',
      runStatus: '',
      runStatusall: '',
      column: [
        { prop: 'devNumber', label: this.$t('manipulation.airNum') },
        { prop: 'devModelName', label: this.$t('manipulation.airModel') },
        { prop: 'elevatorBrandName', label: this.$t('manipulation.elevatorBrand') },
        { prop: 'towerNumber', label: this.$t('manipulation.buildNum') },
        { prop: 'stairsNumber', label: this.$t('manipulation.ladderNum') },
        { prop: 'devCodeDec', label: this.$t('manipulation.deviceAdressNum') },
        { prop: 'imei', label: this.$t('manipulation.comBoard') },

        { prop: 'onlineFlag1', label: this.$t('manipulation.comStatus') },
        { prop: 'workStatus1', label: this.$t('manipulation.workStatus') },
        { prop: 'runStatus1', label: this.$t('manipulation.operaMode') },
      ],
      dialogStationVisible: false,
      title: '',
      deviceinfo: [],
      onLine: true,
      sleepStatus: '',
      sleepStatus1: '',
      runval: "",
      sleepval: '',
      proname: '',

      page: {
        size: 10,
        current: 1
      },
      totals: 0,
      devid: 0,//储存项目id,
      runStatusnum: '',
      sleepStatusnum: '',
      ins: [],
      timer1: null,
      currentStateRequestId: 0,
      commandSubmitting: false,
      commandRequestId: 0,
      commandExpectedResponses: 0,
      commandReceivedResponses: 0,
      commandSocketInfo: null,
      commandSocketIds: [],
      commandBatchId: null,
      commandStatusTimer: null
    }
  },
  computed: {
    ...mapGetters(["stationObj"])
  },
  watch: {

  },
  created() {
    console.log(this.stationObj)
    if (this.stationObj.proid) {
      this.devid = this.stationObj.proid
    }

    this.getdevice()
    this.getdeviceinfo()

    this.getmultiplecurrent()

  },
  beforeDestroy() {
    this.finishCommand()
  },
  methods: {
    getRowKeys(row) {
      return row.id
    },
    handleCurrentChange(val) {
      this.page.current = val
      this.getdevice()
    },
    // throttle(func, delay) {
    //   var timer = null;
    //   return function () {
    //     var context = this;
    //     var args = arguments;
    //     if (!timer) {
    //       timer = setTimeout(function () {
    //         func.apply(context, args);
    //         timer = null;
    //       }, delay);
    //     }
    //   }
    // },
    setdevice:throttle(function(){
      setTimeout(() => {
        this.getdevice()
      }, 4000)
    },2000) ,
    getsocket(info, ids, name) {
      if (this.commandSubmitting) {
        return false
      }
      this.commandSubmitting = true
      this.loading = true
      this.commandRequestId += 1
      const requestId = this.commandRequestId
      const responseKeys = Object.create(null)
      const responseDevices = this.unique(info.filter(v => v && v.onenetId).map(v => v.onenetId))
      const commandCountByGateway = Object.create(null)
      info.filter(v => v && v.onenetId && v.devCode).forEach(v => {
        commandCountByGateway[v.onenetId] =
          (commandCountByGateway[v.onenetId] || 0) + ids.length
      })
      const maxSequentialCommands = Math.max(
        1,
        ...Object.keys(commandCountByGateway).map(key => commandCountByGateway[key])
      )
      const commandTimeout = maxSequentialCommands * 12000 + 5000
      this.commandExpectedResponses = responseDevices.length
      this.commandReceivedResponses = 0
      this.commandSocketInfo = info
      this.commandSocketIds = ids
      clearTimeout(this.timer1)
      this.ins = []

      info.map((v, i) => {
        if (v && v.onenetId && v.devCode) {
          ids.map((item, index) => {
            const socketIndex = index + i * ids.length
            const topic = v.onenetId + v.devCode + item
            initWebSocket(`wss://heshanprod.thingcom.com/ws?type=4&topic=${topic}`, socketIndex)
            sendSock('', socketIndex, (event) => {
              if (requestId !== this.commandRequestId || !this.commandSubmitting || !event || typeof event.data !== 'string') {
                return
              }
              const message = event.data
              if (message.indexOf(`${this.$t('manipulation.opeSec')}`) === -1 && message.indexOf(`${this.$t('manipulation.opefau')}`) === -1) {
                return
              }
              const responseKey = v.onenetId
              if (responseKeys[responseKey]) {
                return
              }
              responseKeys[responseKey] = true
              this.commandReceivedResponses += 1
              this.ins.push(name + message)
              this.getdevice()
              this.setdevice()
              if (this.activeName === 'first') {
                this.getdeviceinfo()
              }
              this.getmultiplecurrent()
              if (ids[0] == '14' && this.activeName != 'first') {
                this.runStatusall = this.runStatusnum
              }
              if (ids[0] == '11' && this.activeName != 'first') {
                this.sleepStatus1 = this.sleepStatusnum
              }
            })
          })
        }
      })
      this.timer1 = setTimeout(() => {
        if (requestId === this.commandRequestId && this.commandSubmitting && !this.commandBatchId) {
          this.commandFailure(this.$t('manipulation.questTimedOut'))
        }
      }, commandTimeout)
      return true
    },
    commandAccepted(response) {
      const batchId = response && response.data && response.data.data && response.data.data.batchId
      if (!batchId || !this.commandSubmitting) {
        this.commandFailure(this.$t('manipulation.opefau'))
        return
      }
      this.startCommandPolling(batchId, this.commandRequestId)
    },
    startCommandPolling(batchId, requestId) {
      this.commandBatchId = batchId
      clearTimeout(this.timer1)
      clearInterval(this.commandStatusTimer)
      const poll = () => {
        if (requestId !== this.commandRequestId || !this.commandSubmitting) {
          return
        }
        getCommandBatch(batchId).then(response => {
          if (requestId !== this.commandRequestId || !this.commandSubmitting) {
            return
          }
          const batch = response && response.data && response.data.data
          if (!batch) {
            return
          }
          if (batch.status === 'SUCCESS') {
            this.$message.success(this.$t('manipulation.opeSucc'))
            this.finishCommand()
          } else if (batch.status === 'FAILED' || batch.status === 'EXPIRED') {
            this.commandFailure(batch.status === 'EXPIRED'
              ? this.$t('manipulation.questTimedOut')
              : this.$t('manipulation.opefau'))
          }
        }).catch(() => {})
      }
      poll()
      this.commandStatusTimer = setInterval(poll, 1000)
    },
    finishCommand() {
      clearTimeout(this.timer1)
      clearInterval(this.commandStatusTimer)
      this.timer1 = null
      this.commandStatusTimer = null
      const info = this.commandSocketInfo
      const ids = this.commandSocketIds
      this.commandSocketInfo = null
      this.commandSocketIds = []
      this.commandBatchId = null
      this.commandSubmitting = false
      this.loading = false
      if (info && ids && ids.length) {
        this.closesocket(info, ids)
      }
    },
    commandFailure(message) {
      this.finishCommand()
      if (message) {
        this.$message.error(message)
      }
    },
    unique(arr) {

      return Array.from(new Set(arr));
    },

    closesocket(info, ids) {
      info.map((v, i) => {
        ids.map((item, index) => {
          websocketclose(index + i * ids.length)
        })
      })

    },
    //获取实时数据
    getmultiplecurrent:throttle(function(){
      const requestId = ++this.currentStateRequestId
      const requestContext = {
        onenetId: this.stationObj.onenetId,
        devCode: this.stationObj.devcode
      }
      this.runStatus = ''
      this.runval = ''
      this.sleepStatus = ''
      this.sleepval = ''
      const readCurrent = (streamId, onValue) => {
        multiplecurrent({
          onenetId: requestContext.onenetId,
          devCode: requestContext.devCode,
          streamIds: streamId
        }).then(res => {
          if (!isCurrentRequest(requestId, this.currentStateRequestId, requestContext, {
            onenetId: this.stationObj.onenetId,
            devCode: this.stationObj.devcode
          })) {
            return
          }
          if (res.data.code !== 200 || !Array.isArray(res.data.data)) {
            return
          }
          const item = res.data.data.find(v => v && String(v.streamId).toUpperCase() === streamId)
          if (!item || item.available === false || item.monitorValue === null || item.monitorValue === undefined || item.monitorValue === '') {
            return
          }
          onValue(String(item.monitorValue))
        }).catch(() => {})
      }

      readCurrent('14', value => {
        this.runStatus = value
        this.runval = value
      })
      readCurrent('11', value => {
        this.sleepval = value
        this.sleepStatus = value.length > 1 ? value.charAt(1) : ''
      })
    },1000) ,
    getdevice:throttle( function() {
      console.log('getdevice',111111111111)
      getDeviceListById({ id: this.devid, ...this.page }).then(res => {

        if (res.data.code === 200) {
          res.data.data.records.map((item, index) => {
            item.index = index + 1
            item.workStatus1 = formatBinaryStatus(item.workStatus, {
              zero: this.$t('realtimeinfo.turnOff'),
              one: this.$t('realtimeinfo.powerOn'),
              unreported: this.$t('manipulation.unreported')
            })
            item.runStatus1 = formatRunStatus(item.runStatus, {
              manual: this.$t('realtimeinfo.manual'),
              timing: this.$t('manipulation.timing'),
              unreported: this.$t('manipulation.unreported')
            })
            item.onlineFlag1 = formatBinaryStatus(item.onlineFlag, {
              zero: this.$t('realtimeinfo.offLine'),
              one: this.$t('realtimeinfo.onLine'),
              unreported: this.$t('manipulation.unreported')
            })
          })

          this.totals = res.data.data.total

          this.page.current = res.data.data.current
          this.devicelist = res.data.data.records
        }
      })
    },1000),
    getdeviceinfo:throttle(function(){
      deviceinfo({ id: this.stationObj.devid ? this.stationObj.devid : 0 }).then(res => {
        if (res.data.code == 200) {

          let a = res.data.data
          this.deviceinfo = []
          a.workStatus1 = formatBinaryStatus(a.workStatus, {
            zero: this.$t('realtimeinfo.turnOff'),
            one: this.$t('realtimeinfo.powerOn'),
            unreported: this.$t('manipulation.unreported')
          })
          a.runStatus1 = formatRunStatus(a.runStatus, {
            manual: this.$t('realtimeinfo.manual'),
            timing: this.$t('realtimeinfo.timing'),
            unreported: this.$t('manipulation.unreported')
          })
          a.onlineFlag1 = formatBinaryStatus(a.onlineFlag, {
            zero: this.$t('realtimeinfo.offLine'),
            one: this.$t('realtimeinfo.onLine'),
            unreported: this.$t('manipulation.unreported')
          })
          this.deviceinfo.push(a)
          this.getprojectinfo()
        }
      })
    },1000) ,
    getprojectinfo() {
      projectinfo({ id: this.stationObj.proid ? this.stationObj.proid : 0 }).then(res => {
        if (res.data.code == 200) {
          this.deviceinfo.push(res.data.data)
          this.proname = res.data.data.projectName
        }
      })
    },
    setsleep(num) {
      if (this.commandSubmitting) {
        return
      }
      let obj = []
      let socketInfo = this.deviceinfo
      if (this.activeName === 'first') {
        if (!this.deviceinfo[0]) {
          return
        }
        obj.push({
          streamId: 11,
          monitorValue: { sleepStatus: num, monitorValue: this.sleepval },
          type: 4,
          deviceId: this.deviceinfo[0].id,
          onenetId: this.deviceinfo[0].onenetId,
          devCode: this.deviceinfo[0].devCode
        })
      } else {
        socketInfo = this.$refs.datatable.selection
        if (!socketInfo || socketInfo.length < 1) {
          this.$message.error(this.$t('manipulation.pleChoiceAir'))
          return
        }
        socketInfo.map((item) => {
          obj.push({
            streamId: 11,
            monitorValue: { sleepStatus: num, monitorValue: this.sleepval },
            type: 4,
            deviceId: item.id,
            onenetId: item.onenetId,
            devCode: item.devCode
          })
        })
      }
      if (!this.getsocket(socketInfo, ['11'], this.$t('manipulation.sleepMode') + ':')) {
        return
      }
      Promise.resolve().then(() => multiplewrite(obj)).then(res => {
        if (res && res.data && res.data.code == 200) {
          if (this.activeName != 'first') {
            this.sleepStatusnum = num
          }
          this.commandAccepted(res)
        } else {
          this.commandFailure((res && res.data && (res.data.msg || res.data.message)) || this.$t('manipulation.opefau'))
        }
      }).catch(() => {
        this.commandFailure(this.$t('manipulation.opefau'))
      })
    },
    setwrite(num) {
      if (this.commandSubmitting) {
        return
      }
      let obj = []
      let socketInfo = this.deviceinfo
      if (this.activeName === 'first') {
        if (!this.deviceinfo[0]) {
          return
        }
        obj.push({
          streamId: 14,
          monitorValue: { runStatus: num, monitorValue: this.runval },
          type: 1,
          deviceId: this.deviceinfo[0].id,
          onenetId: this.deviceinfo[0].onenetId,
          devCode: this.deviceinfo[0].devCode
        })
      } else {
        socketInfo = this.$refs.datatable.selection
        if (!socketInfo || socketInfo.length < 1) {
          this.runStatusall = num
          return
        }
        socketInfo.map((item) => {
          obj.push({
            streamId: 14,
            monitorValue: { runStatus: num, monitorValue: this.runval },
            type: 1,
            deviceId: item.id,
            onenetId: item.onenetId,
            devCode: item.devCode
          })
        })
      }
      if (!this.getsocket(socketInfo, ['14'], this.$t('manipulation.operaMode') + ':')) {
        return
      }
      Promise.resolve().then(() => multiplewrite(obj)).then(res => {
        if (res && res.data && res.data.code == 200) {
          if (this.activeName != 'first') {
            this.runStatusnum = num
          }
          this.commandAccepted(res)
        } else {
          this.commandFailure((res && res.data && (res.data.msg || res.data.message)) || this.$t('manipulation.opefau'))
        }
      }).catch(() => {
        this.commandFailure(this.$t('manipulation.opefau'))
      })
    },
    handleClick(val) {

      if (val.name === 'first') {
        this.onLine = true
      } else {
        this.onLine = false
      }
      this.activeName = val.name
    },
    par_set(val, num) {
      if (this.commandSubmitting) {
        return
      }

      if (this.activeName === 'first') {
        if (val == 'time' && this.runStatus == '1') {
          this.title = this.$t('manipulation.timModeParSetting')
          this.dialogStationVisible = true
        } else if (val == 'hanld' && this.runStatus == '0') {
          this.title = this.$t('manipulation.manModeParSetting')
          this.dialogStationVisible = true
        }
        this.$nextTick(() => {
          this.$refs.parmodel.getallinfo(this.deviceinfo)
        })
      } else if (this.activeName === 'second') {
        if (this.$refs.datatable.selection.length < 1) {
          this.$message.error(this.$t('manipulation.pleChoiceAir'))
          return
        }
        let istrue = this.$refs.datatable.selection.filter(v => v.runStatus != num)
        if (istrue.length > 0) {
          this.$message.error(this.$t('manipulation.exDifAir') + '!')
          return
        }
        if (val == 'time' && this.runStatusall == '1') {
          this.title = this.$t('manipulation.timModeParSetting')
          this.dialogStationVisible = true
        } else if (val == 'hanld' && this.runStatusall == '0') {
          this.title = this.$t('manipulation.manModeParSetting')
          this.dialogStationVisible = true
        }


        this.$nextTick(() => {
          this.$refs.parmodel.getallinfo(this.$refs.datatable.selection)
        })

      }
    },
    parsocket(val) {

      if (this.activeName === 'first') {
        if (val == 'time') {
          this.getsocket(this.deviceinfo, ['15', '16', '17', '18', '20', '28', '30', '38', '40', '48', '50', '58', '60'], this.$t('manipulation.timMode') + ':')
        } else if (val == 'hanld') {
          this.getsocket(this.deviceinfo, ['13', '12', '11'], this.$t('manipulation.manMode') + ':')
        }
      } else if (this.activeName === 'second') {
        if (val == 'time') {
          this.getsocket(this.$refs.datatable.selection, ['15', '16', '17', '18', '20', '28', '30', '38', '40', '48', '50', '58', '60'], this.$t('manipulation.timMode') + ':')
        } else if (val == 'hanld' && this.runStatus == '0') {

          this.getsocket(this.$refs.datatable.selection, ['13', '12', '11'], this.$t('manipulation.manMode') + ':')
        }
      }
    },
    closepar(num) {
      this.dialogStationVisible = false
      if (num === '1') {
        this.loading = true

      }
    },
    selectStation(data) {
      if (Array.isArray(data)) {
        this.deviceinfo = data
        this.getmultiplecurrent()
      } else {

        this.proname = data.projectName
        this.devid = data.id

        this.page.current = 1
        this.$refs.datatable.clearSelection()
        this.getdevice()
      }
    },
  }
}
</script>
<style lang='scss'>
.manipulation {
  padding: 0 15px !important;
  flex: 1;
  overflow: auto;
  margin-bottom: 20px;

  .mantit {
    display: flex;
    padding: 10px 0;
    align-items: center;

    .p1 {
      width: 3px;
      height: 18px;
      background: #01AAA7;
      margin-right: 2px;
    }

    .p2 {
      width: 5px;
      height: 18px;
      background: #01AAA7;
      margin-right: 5px;
    }

    .titinfo {
      color: #333;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .proname {
      margin-left: 20px;
      border-radius: 5px;
      border: 1px solid #aaa;
      padding: 6px 20px
    }
  }

  .deviceinfo {
    background: #F2FBFB;
    width: 70%;
    padding: 1%;

    .info_con {
      display: flex;
      flex-wrap: wrap;

      .info_list {
        width: 25%;
        display: flex;
        padding: 10px 0;

        .info_name {
          width: 40%;
        }

        .info_val {
          width: 60%;
        }
      }

      .info_list1 {
        width: 50%;

        .info_name {
          width: 20%;
        }

        .info_val {
          width: 80%;
        }
      }

    }
  }

  .instr {
    background: #F2FBFB;
    width: 70%;
    padding: 1%;

    .instr_con {
      p {
        font-size: 14px;
      }
    }
  }

  .oper {
    background: #F2FBFB;
    //    float: left;
    padding: 3%;
    width: 42%;

    .oper_con {
      display: flex;
      align-items: center;
      justify-content: center;

    }
  }

  .oper_left {
    width: 250px;
    display: flex;
    justify-content: center;

    .oper_but {
      width: 150px;
      height: 40px;
      color: #fff;
      letter-spacing: 1px;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;
      //    background: #67C23A;
      background: #ccc;
      cursor: pointer;
    }

    .oper_but1 {
      background: #67C23A;
    }

    .oper_but2 {
      background: #DAA342;
    }

    .disab {
      background: #ccc;
    }
  }

  .par {
    margin-bottom: 10px;

    .par_left {
      width: 42%;
      float: left;
      background: #F2FBFB;
      padding: 3%;

      .par_con {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .par_right {
      margin-left: 3%;
    }
  }
}
</style>
